module.exports = __webpack_public_path__ + "img/superadmin copy.fd4cf41c.svg";